import React from 'react';
import TextComponent from '@media-spec/core/src/components/TextComponent';
import * as S from './Quote.module.css';
import { IQuoteProps } from '@components/Quote/Quote.types';
import QuoteIcon from '@images/quote.svg';

import classnames from 'classnames';

export const Quote: React.FunctionComponent<IQuoteProps> = ({
  text,
  className,
}) => (
  <div className={classnames(className, S.quote)}>
    <QuoteIcon />
    <TextComponent content={[text]} />
  </div>
);
